import APIClient from '@/shared/http/clients/api'

const APIBusiness = process.env.APIBaseURLBusinessCommon
const resourceName = 'ObraClassificacao'

const GetAll = (companyId, data = {}, config = {}) => APIClient.get(`${APIBusiness}/${resourceName}/${companyId}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusiness}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusiness}/${resourceName}`, data, config)
const Delete = (id, data = {}, config = {}) => APIClient.delete(`${APIBusiness}/${resourceName}/${id}`, data, config)

const WkClassifRepository = {
  GetAll,
  Create,
  Update,
  Delete
}

export default WkClassifRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/workclassification.js